import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {GatewayActionComponent} from '@components/administration/gateway/gateway-action/gateway-action.component';
import {
  GatewayAdcSettingComponent
} from '@components/administration/gateway/gateway-configuration/gateway-adc/gateway-adc-setting/gateway-adc-setting.component';
import {
  GatewayAdcComponent
} from '@components/administration/gateway/gateway-configuration/gateway-adc/gateway-adc.component';
import {
  GatewayConfigurationComponent
} from '@components/administration/gateway/gateway-configuration/gateway-configuration.component';
import {
  GatewayAliasesActionComponent
} from '@components/administration/gateway/gateway-configuration/gateway-connections/gateway-aliases/gateway-aliases-action/gateway-aliases-action.component';
import {
  GatewayAliasesEditComponent
} from '@components/administration/gateway/gateway-configuration/gateway-connections/gateway-aliases/gateway-aliases-edit/gateway-aliases-edit.component';
import {
  GatewayAliasesComponent
} from '@components/administration/gateway/gateway-configuration/gateway-connections/gateway-aliases/gateway-aliases.component';
import {
  GatewayArraysEditComponent
} from '@components/administration/gateway/gateway-configuration/gateway-connections/gateway-arrays/gateway-arrays-edit/gateway-arrays-edit.component';
import {
  GatewayArraysComponent
} from '@components/administration/gateway/gateway-configuration/gateway-connections/gateway-arrays/gateway-arrays.component';
import {
  GatewayConnectionsComponent
} from '@components/administration/gateway/gateway-configuration/gateway-connections/gateway-connections.component';
import {
  GatewayDetailsComponent
} from '@components/administration/gateway/gateway-configuration/gateway-details/gateway-details.component';
import {
  GatewayCommunicationModalComponent
} from '@components/administration/gateway/gateway-configuration/gateway-functions/gateway-communication-modal/gateway-communication-modal.component';
import {
  GatewayFunctionsModalComponent
} from '@components/administration/gateway/gateway-configuration/gateway-functions/gateway-functions-modal/gateway-functions-modal.component';
import {
  GatewayFunctionsComponent
} from '@components/administration/gateway/gateway-configuration/gateway-functions/gateway-functions.component';
import {
  GatewayGeneralComponent
} from '@components/administration/gateway/gateway-configuration/gateway-general/gateway-general.component';
import {
  GatewayLogIotActionsComponent
} from '@components/administration/gateway/gateway-configuration/gateway-log-iot/gateway-log-iot-actions/gateway-log-iot-actions.component';
import {
  GatewayLogIotComponent
} from '@components/administration/gateway/gateway-configuration/gateway-log-iot/gateway-log-iot.component';
import {
  GatewayLogComponent
} from '@components/administration/gateway/gateway-configuration/gateway-log/gateway-log.component';
import {
  GatewayModbusRegisterSignalsComponent
} from '@components/administration/gateway/gateway-configuration/gateway-modbus/gateway-modbus-slave/gateway-modbus-register/gateway-modbus-register-signals/gateway-modbus-register-signals.component';
import {
  GatewayModbusRegisterComponent
} from '@components/administration/gateway/gateway-configuration/gateway-modbus/gateway-modbus-slave/gateway-modbus-register/gateway-modbus-register.component';
import {
  GatewayModbusSlaveComponent
} from '@components/administration/gateway/gateway-configuration/gateway-modbus/gateway-modbus-slave/gateway-modbus-slave.component';
import {
  GatewayModbusComponent
} from '@components/administration/gateway/gateway-configuration/gateway-modbus/gateway-modbus.component';
import {
  GatewayServiceComponent
} from '@components/administration/gateway/gateway-configuration/gateway-service/gateway-service.component';
import {
  IbaConfigurationModalComponent
} from '@components/administration/gateway/gateway-configuration/gateway-service/iba-configuration-modal/iba-configuration-modal.component';
import {GatewayEditComponent} from '@components/administration/gateway/gateway-edit/gateway-edit.component';
import {GatewayRoutingModule} from '@components/administration/gateway/gateway-routing.module';
import {GatewayUpdateComponent} from '@components/administration/gateway/gateway-update/gateway-update.component';
import {GatewayComponent} from '@components/administration/gateway/gateway.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from '@shared/shared.module';
import {FilesizePipe} from 'src/app/shared/filesize-pipe/filesize.pipe';
import {MetadataModule} from '@components/administration/metadata/metadata.module';

@NgModule({
  declarations: [
    GatewayComponent,
    GatewayActionComponent,
    GatewayEditComponent,
    GatewayConfigurationComponent,
    GatewayUpdateComponent,
    GatewayDetailsComponent,
    GatewayFunctionsComponent,
    GatewayFunctionsModalComponent,
    GatewayConnectionsComponent,
    GatewayAliasesComponent,
    GatewayArraysComponent,
    GatewayAliasesEditComponent,
    GatewayArraysEditComponent,
    GatewayServiceComponent,
    IbaConfigurationModalComponent,
    GatewayLogComponent,
    GatewayModbusComponent,
    GatewayAdcComponent,
    GatewayGeneralComponent,
    GatewayAdcSettingComponent,
    GatewayModbusSlaveComponent,
    GatewayModbusRegisterComponent,
    GatewayModbusRegisterSignalsComponent,
    GatewayLogIotComponent,
    GatewayLogIotActionsComponent,
    GatewayAliasesActionComponent,
    GatewayCommunicationModalComponent,
    FilesizePipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    GatewayRoutingModule,
    TranslateModule,
    NgbModule,
    SharedModule,
    ReactiveFormsModule,
    NgSelectModule,
    FormsModule,
    MetadataModule
  ],
  exports: [
    GatewayComponent
  ]
})

export class GatewayModule {

}
